"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Loading = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        background: (0, _mui.alpha)(theme.palette.common.white, 0.5),
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        zIndex: 999
    };
});
const Loading = exports.Loading = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { formatMessage } = (0, _hooks.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.CircularProgress, {
            color: "primary",
            "aria-label": formatMessage('loading')
        })
    });
});
